var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('left-navigation'),_c('top-navigation'),_c('v-main',[_c('router-view')],1),_c('e-notif'),_c('overlay'),_c('v-footer',{attrs:{"app":""}},[_c('v-spacer'),_c('VersionInfo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }